import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgFemaleGlyphSecondary(props) {
  return jsx("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "M32.11 20.05c0-4.44-3.61-8.05-8.05-8.05-4.44 0-8.06 3.61-8.06 8.05 0 4.19 3.21 7.64 7.31 8.02v3.36h-2.3c-.41 0-.75.34-.75.75s.34.75.75.75h2.29v2.38c0 .41.34.75.75.75s.75-.34.75-.75v-2.38h2.29c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-2.28v-3.36c4.09-.38 7.3-3.83 7.3-8.02Zm-14.61 0c0-3.61 2.94-6.55 6.56-6.55a6.56 6.56 0 0 1 6.55 6.55c0 3.62-2.94 6.56-6.55 6.56-3.62 0-6.56-2.94-6.56-6.56Z",
    fill: "currentColor"
  }));
}

export { SvgFemaleGlyphSecondary as default };
